import {
  FETCH_PROTHEUS_STATUS,
  FETCH_PROTHEUS_STATUS_ERROR,
  UPDATE_PROTHEUS_TOKEN,
  UPDATE_PROTHEUS_TOKEN_ERROR,
  REFRESH_PROTHEUS_TOKEN,
  REFRESH_PROTHEUS_TOKEN_ERROR,
  RESET_PROTHEUS_INFO,
} from '../actions/types';

const INITIAL_STATE = {
  protheusStatus: null,
  protheusStatusError: null,
  updateTokenSuccess: null,
  updateTokenError: null,
  refreshTokenSuccess: null,
  refreshTokenError: null,
};

const protheusReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PROTHEUS_STATUS:
      return {
        ...state,
        protheusStatus: action.payload,
        protheusStatusError: null,
      };

    case FETCH_PROTHEUS_STATUS_ERROR:
      return {
        ...state,
        protheusStatusError: action.payload,
      };

    case UPDATE_PROTHEUS_TOKEN:
      return {
        ...state,
        updateTokenSuccess: action.payload.message || 'Tokens atualizados com sucesso!',
        protheusStatus: action.payload.data || state.protheusStatus,
        updateTokenError: null,
      };

    case UPDATE_PROTHEUS_TOKEN_ERROR:
      return {
        ...state,
        updateTokenError: action.payload,
        updateTokenSuccess: null,
      };

    case REFRESH_PROTHEUS_TOKEN:
      return {
        ...state,
        refreshTokenSuccess: action.payload.message || 'Token renovado com sucesso!',
        protheusStatus: action.payload.data || state.protheusStatus,
        refreshTokenError: null,
      };

    case REFRESH_PROTHEUS_TOKEN_ERROR:
      return {
        ...state,
        refreshTokenError: action.payload,
        refreshTokenSuccess: null,
      };

    case RESET_PROTHEUS_INFO:
      return {
        ...state,
        updateTokenSuccess: null,
        updateTokenError: null,
        refreshTokenSuccess: null,
        refreshTokenError: null,
      };

    default:
      return state;
  }
};

export default protheusReducer;
